import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "subscribeBoxC",
  "use": "subscribeBoxC-usage",
  "viewBox": "0 0 942.2 443.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 942.2 443.3\" id=\"subscribeBoxC\">\n\t<path d=\"M867 163.4c108.6 86.7 86.1 180.3 17.6 219.9-94.4 50.5-182.8 16-234.7-24.2-86.1-66.7-166.3-186.6-98.5-272.4 55.5-70.4 207-10 315.6 76.7z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol